import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import IconMenu from './IconMenu';
import ClientProvider from './client';
export default createDemo(import.meta.url, IconMenu, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/menus/demos/icon/IconMenu.tsx",
    "fileName": "IconMenu.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Divider from '@mui/material/Divider';\nimport Paper from '@mui/material/Paper';\nimport MenuList from '@mui/material/MenuList';\nimport MenuItem from '@mui/material/MenuItem';\nimport ListItemText from '@mui/material/ListItemText';\nimport ListItemIcon from '@mui/material/ListItemIcon';\nimport Typography from '@mui/material/Typography';\nimport ContentCut from '@mui/icons-material/ContentCut';\nimport ContentCopy from '@mui/icons-material/ContentCopy';\nimport ContentPaste from '@mui/icons-material/ContentPaste';\nimport Cloud from '@mui/icons-material/Cloud';\n\nexport default function IconMenu() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 2,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <Paper sx={{ width: 320, maxWidth: '100%' }}>\n      <MenuList>\n        <MenuItem>\n          <ListItemIcon>\n            <ContentCut fontSize=\"small\" />\n          </ListItemIcon>\n          <ListItemText>Cut</ListItemText>\n          <Typography variant=\"body2\" sx={{ color: 'text.secondary' }}>\n            ⌘X\n          </Typography>\n        </MenuItem>\n        <MenuItem>\n          <ListItemIcon>\n            <ContentCopy fontSize=\"small\" />\n          </ListItemIcon>\n          <ListItemText>Copy</ListItemText>\n          <Typography variant=\"body2\" sx={{ color: 'text.secondary' }}>\n            ⌘C\n          </Typography>\n        </MenuItem>\n        <MenuItem>\n          <ListItemIcon>\n            <ContentPaste fontSize=\"small\" />\n          </ListItemIcon>\n          <ListItemText>Paste</ListItemText>\n          <Typography variant=\"body2\" sx={{ color: 'text.secondary' }}>\n            ⌘V\n          </Typography>\n        </MenuItem>\n        <Divider />\n        <MenuItem>\n          <ListItemIcon>\n            <Cloud fontSize=\"small\" />\n          </ListItemIcon>\n          <ListItemText>Web Clipboard</ListItemText>\n        </MenuItem>\n      </MenuList>\n    </Paper>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 54,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Divider from '@mui/material/Divider';\nimport Paper from '@mui/material/Paper';\nimport MenuList from '@mui/material/MenuList';\nimport MenuItem from '@mui/material/MenuItem';\nimport ListItemText from '@mui/material/ListItemText';\nimport ListItemIcon from '@mui/material/ListItemIcon';\nimport Typography from '@mui/material/Typography';\nimport ContentCut from '@mui/icons-material/ContentCut';\nimport ContentCopy from '@mui/icons-material/ContentCopy';\nimport ContentPaste from '@mui/icons-material/ContentPaste';\nimport Cloud from '@mui/icons-material/Cloud';\n\nexport default function IconMenu() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 2
        },
        "    <Paper sx={{ width: 320, maxWidth: '100%' }}>\n      <MenuList>\n        <MenuItem>\n          <ListItemIcon>\n            <ContentCut fontSize=\"small\" />\n          </ListItemIcon>\n          <ListItemText>Cut</ListItemText>\n          <Typography variant=\"body2\" sx={{ color: 'text.secondary' }}>\n            ⌘X\n          </Typography>\n        </MenuItem>\n        <MenuItem>\n          <ListItemIcon>\n            <ContentCopy fontSize=\"small\" />\n          </ListItemIcon>\n          <ListItemText>Copy</ListItemText>\n          <Typography variant=\"body2\" sx={{ color: 'text.secondary' }}>\n            ⌘C\n          </Typography>\n        </MenuItem>\n        <MenuItem>\n          <ListItemIcon>\n            <ContentPaste fontSize=\"small\" />\n          </ListItemIcon>\n          <ListItemText>Paste</ListItemText>\n          <Typography variant=\"body2\" sx={{ color: 'text.secondary' }}>\n            ⌘V\n          </Typography>\n        </MenuItem>\n        <Divider />\n        <MenuItem>\n          <ListItemIcon>\n            <Cloud fontSize=\"small\" />\n          </ListItemIcon>\n          <ListItemText>Web Clipboard</ListItemText>\n        </MenuItem>\n      </MenuList>\n    </Paper>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "totalLines": 54,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "@mui/material/Divider",
      "@mui/material/Paper",
      "@mui/material/MenuList",
      "@mui/material/MenuItem",
      "@mui/material/ListItemText",
      "@mui/material/ListItemIcon",
      "@mui/material/Typography",
      "@mui/icons-material/ContentCut",
      "@mui/icons-material/ContentCopy",
      "@mui/icons-material/ContentPaste",
      "@mui/icons-material/Cloud"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
